import '../../App.css';
import React, { useContext, useEffect, useRef, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { FaTimes, FaPlus } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { SlOptionsVertical } from 'react-icons/sl';
import { StyleContext } from '../../context/StyleContext';

function ModalEditarCargo({currentPage}) {
    const { EditarCargo, EdicaoCargo, setEdicaoCargo, ListaCargo, setModalEditarCargo, Permissao, CompetenciaCargo, setError, AdicionarCargoCompetencia, ListaCargoCompetencia, ExcluirCargoCompetencia, ListaCompetencia, Competencias } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [competenciaKey, setCompetenciaKey] = useState("")
    const competenciaRef = useRef()

    const handleChange = (event) => {
        setEdicaoCargo({ ...EdicaoCargo, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        ListaCargo()
        ListaCompetencia()
        ListaCargoCompetencia()
    }, [])

    const adicionarCompetencia = () => {
        if (!competenciaKey || competenciaKey === "0") {
            setError("Selecione uma competência.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        AdicionarCargoCompetencia(competenciaKey)
            .then(() => {
                setCompetenciaKey("");
                competenciaRef.current.value = 0;
            });
    };

    useEffect(() => {
        if (CompetenciaCargo && CompetenciaCargo.length > 0) {
            const competenciasFormatadas = CompetenciaCargo.map(item => ({
                cargoKey: item.key,
                competenciaKey: item.competencia.key
            }));
            setEdicaoCargo(prev => ({
                ...prev,
                competencias: competenciasFormatadas
            }));
        } else {
            setEdicaoCargo(prev => ({ ...prev, competencias: [] }));
        }
    }, [CompetenciaCargo]);

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar cargo</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarCargo(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Visão Geral</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cargo</Form.Label>
                                            <Form.Control maxLength={100} defaultValue={EdicaoCargo.descricao} onChange={handleChange} name="descricao" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="competencias" title={<span>Competências</span>}>
                                <h1 className='h1-modal'>Competências</h1>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}>
                                    <Col>
                                        <Form.Group>
                                            <Form.Select ref={competenciaRef} aria-label="Default select example" onChange={(e) => setCompetenciaKey(e.target.value)}>
                                                <option value={0}>Selecione</option>
                                                {Competencias &&
                                                    Competencias?.map((c) => {
                                                        return (
                                                            <option key={c.id} value={c.key}>{c.descricao}</option>
                                                        )

                                                    })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <button type="button" className="btn-dash btn-criar btn-add" style={btnCriar} onClick={() => adicionarCompetencia()}><FaPlus /></button>
                                </div>
                                <hr />
                                <Row>
                                    <div style={{ maxHeight: '30vh', width: '100%', overflowY: 'auto' }}>
                                        {CompetenciaCargo && CompetenciaCargo.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario">
                                                            <SlOptionsVertical style={{ marginRight: '15px' }} className='span-bsc'/>
                                                            <span className='span-bsc'>{item.competencia.descricao}</span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirCargoCompetencia(item.key)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarCargo(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={() => EditarCargo(currentPage)}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarCargo